import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { cloudwatchRumConfigSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

export const useAPIGetCloudwatchRumConfig = () =>
  useQuery({
    queryKey: [API_ENDPOINTS.CLOUDWATCH_RUM_CONFIG],
    queryFn: () =>
      get(API_ENDPOINTS.CLOUDWATCH_RUM_CONFIG, cloudwatchRumConfigSchema),
    staleTime: Infinity,
  })
